import apiClient from './apiClient';

// F90J interface matching backend model
export interface F90J {
  f90j_01: string;  // 核准序號
  f90j_11: string;  // 員工代號
  f90j_91: string;  // 建立人員代號
  f90j_92: string | null;  // 建立日期
  f90j_93: string;  // 最後異動人員代號
}

export interface ListResponse {
  data: F90J[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  code: string;
  message: string;
}

const BASE = '/api/vp-approval-priority';

const vpApprovalPriorityApi = {
  list: async (page = 1, size = 100, keyword?: string): Promise<ListResponse> => {
    if (keyword) {
      const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
      return res.data;
    }
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  search: async (keyword: string, page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
    return res.data;
  },

  get: async (code: string): Promise<F90J> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(code)}`);
    return res.data;
  },

  create: async (data: Partial<F90J>): Promise<F90J> => {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  update: async (code: string, data: Partial<F90J>): Promise<F90J> => {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  delete: async (code: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(code)}`);
  },
};

export default vpApprovalPriorityApi;
